import React, {Component, Fragment} from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import FareRuleList from './FareRuleList';
import { Link } from 'react-router-dom';

let permisionActions = [];

export default class FareRules extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.fareRuleState.pageSize,
                pageIndex: this.props.fareRuleState.pageIndex,
            }
        }
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FARE_RULES);
        this.props.getListFareRules(this.state.filters);
    }

    render() {
        const {t} = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, fareRules } = this.props.fareRuleState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'fareRules'}
                        titleHeader={t('navigation.fareRules')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.FARE_RULES.CREATE.path}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <FareRuleList loading={isFetching}
                                  permisions={permisionActions}
                                  fareRules={fareRules}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDeleteFareRule}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onChangeLanguage = () => {
        this.props.getListFareRules(this.state.filters)
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListFareRules(newFilters);
    }

    onDeleteFareRule = (item) => {
        this.props.deleteFareRuleDetail(item, {
            filters: {
                pageSize: this.props.fareRuleState.pageSize,
                pageIndex: this.props.fareRuleState.pageIndex
            }
        });
    }
}

